import { useState, type FormEvent } from 'react';
import { api, setCsrfToken } from '../api';

export function Login({ onAuthenticated }: { onAuthenticated: () => Promise<void> }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function submit(event: FormEvent): Promise<void> {
    event.preventDefault();
    setBusy(true);
    setError('');
    try {
      const result = await api<{ csrfToken: string }>('/api/auth/login', {
        method: 'POST',
        body: JSON.stringify({ email, password }),
      });
      setCsrfToken(result.csrfToken);
      await onAuthenticated();
    } catch (caught) {
      setError(caught instanceof Error ? caught.message : 'Connexion impossible.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="login-page">
      <div className="login-form">
        <span className="login-rule" aria-hidden="true" />
        <p className="eyebrow">Coloc Martigues</p>
        <h1>Bon retour.</h1>
        <form onSubmit={(event) => void submit(event)} className="login-card">
          <label>
            Adresse e-mail
            <input type="email" autoComplete="username" placeholder="vous@exemple.fr" value={email} onChange={(event) => setEmail(event.target.value)} required />
          </label>
          <label>
            Mot de passe
            <input type="password" autoComplete="current-password" placeholder="••••••••••••" value={password} onChange={(event) => setPassword(event.target.value)} required />
          </label>
          {error && <div className="inline-message error" role="alert">{error}</div>}
          <button className="button primary wide" disabled={busy}>{busy ? 'Connexion…' : 'Ouvrir mon espace'}</button>
        </form>
        <p className="login-footnote">Baux · États des lieux · Loyers, réunis au même endroit.</p>
      </div>
    </main>
  );
}

